<template>
  <div class="container__admin">
    <b-container>
      <b-row class="mt-4" align-v="center">
        <b-col align-self="start" class="pt-4">
          <router-link class="text-secondary" to="/welcome">
            <b-icon icon="arrow-left" aria-hidden="true"></b-icon>
            <span> {{ $t('admin.back') }}</span>
          </router-link>
        </b-col>
        <b-col align-self="end" md="3" xl="2" class="bg-white mt-4 p-3 navbar-profile justify-content-center">
          <MenuUser />
        </b-col>
      </b-row>
      <b-row class="my-4">
        <h3>{{ $t('admin.title') }}</h3>
      </b-row>
      <b-row>
        <div style="width: 100%">
          <b-card title="Card Title" no-body class="mb-4">
            <b-card-header header-tag="nav">
              <b-nav card-header tabs class="tabs-card">
                <b-nav-item
                  to="/admin"
                  exact
                  exact-active-class="active"
                  v-if="configRol.administrador.pestana.pdf.permiso"
                  ><b-icon icon="pencil-square" aria-hidden="true" class="mr-2"></b-icon
                  >{{ $t('admin.pdfTitle') }}</b-nav-item
                >
                <b-nav-item
                  to="/admin/users"
                  exact
                  exact-active-class="active"
                  v-if="configRol.administrador.pestana.users.permiso"
                  ><b-icon icon="person" aria-hidden="true" class="mr-2"></b-icon
                  >{{ $t('admin.users.title') }}</b-nav-item
                >
                <b-nav-item
                  to="/admin/pharmacy"
                  exact
                  exact-active-class="active"
                  v-if="configRol.administrador.pestana.pharmacy.permiso"
                  ><img src="../assets/images/farmacia-dark.png" alt="farmacia" class="mr-2" />{{
                    $t('admin.pharmacy.title')
                  }}</b-nav-item
                >
                <b-nav-item
                  to="/admin/auth"
                  exact
                  exact-active-class="active"
                  v-if="configRol.administrador.pestana.auth_programs.permiso"
                  ><b-icon icon="ui-checks" aria-hidden="true" class="mr-2"></b-icon
                  >{{ $t('admin.auth.title') }}</b-nav-item
                >
                <b-nav-item
                  to="/admin/authdos"
                  exact
                  exact-active-class="active"
                  v-if="
                    configRol.administrador.pestana.auth_discounts &&
                      configRol.administrador.pestana.auth_discounts.permiso
                  "
                  ><b-icon icon="ui-checks" aria-hidden="true" class="mr-2"></b-icon
                  >{{ $t('admin.authDiscounts.title') }}</b-nav-item
                >
                <b-nav-item
                  to="/admin/trm"
                  exact
                  exact-active-class="active"
                  v-if="configRol.administrador.pestana.trm.permiso"
                  ><b-icon icon="credit-card" aria-hidden="true" class="mr-2"></b-icon>TRM</b-nav-item
                >
                <b-nav-item
                  to="/admin/medicine"
                  exact
                  exact-active-class="active"
                  v-if="configRol.administrador.pestana.medicines.permiso"
                  ><img src="../assets/images/Medicine.svg" alt="medicine" class="mr-2" style="width: 20px" />{{
                    $t('admin.medicines.title')
                  }}</b-nav-item
                >
                <b-nav-item
                  to="/admin/integrator"
                  exact
                  exact-active-class="active"
                  v-if="configRol.administrador.pestana.integrator.permiso"
                  ><img
                    src="../assets/images/diferenciadores-icon.svg"
                    alt="integrator"
                    class="mr-2"
                    style="width: 20px"
                  />{{ $t('admin.integrator.title') }}</b-nav-item
                >
                <b-nav-item
                  to="/admin/top-cards"
                  exact
                  exact-active-class="active"
                  v-if="configRol.administrador.pestana.topCards.permiso"
                  ><img src="../assets/images/historico-icon.svg" alt="top" class="mr-2" style="width: 20px" />{{
                    $t('admin.top.title')
                  }}</b-nav-item
                >
                <b-nav-item
                  to="/admin/rol"
                  exact
                  exact-active-class="active"
                  v-if="configRol.administrador.pestana.adminRoles.permiso"
                  ><b-icon icon="people" aria-hidden="true" class="mr-2"></b-icon
                  >{{ $t('admin.role.title') }}</b-nav-item
                >
                <b-nav-item
                  to="/admin/bussiness"
                  exact
                  exact-active-class="active"
                  v-if="configRol.administrador.pestana.adminSucursales.permiso"
                  ><b-icon icon="diagram3" aria-hidden="true" class="mr-2"></b-icon
                  >{{ $t('admin.bussiness.title') }}</b-nav-item
                >
                <b-nav-item
                  to="/admin/adminPrograms"
                  exact
                  exact-active-class="active"
                  v-if="configRol.administrador.pestana.adminSucursales.permiso"
                  ><b-icon icon="journal-medical" aria-hidden="true" class="mr-2"></b-icon
                  >{{ $t('admin.bussiness.programsAdmin') }}</b-nav-item
                >
                <b-nav-item
                  to="/admin/islas&matriz"
                  exact
                  exact-active-class="active"
                  v-if="
                    configRol.administrador.pestana.branchMatrix && configRol.administrador.pestana.branchMatrix.permiso
                  "
                  ><b-icon icon="file-spreadsheet" aria-hidden="true" class="mr-2"></b-icon
                  >{{ $t('admin.branchMatriz.branch') }} & {{ $t('admin.branchMatriz.matrix') }}</b-nav-item
                >
                <b-nav-item
                  to="/admin/discounts"
                  v-if="
                    configRol.administrador.pestana.adminDiscounts &&
                      configRol.administrador.pestana.adminDiscounts.permiso
                  "
                  exact
                  exact-active-class="active"
                  ><b-icon icon="cash" aria-hidden="true" class="mr-2"></b-icon
                  >{{ $t('admin.discounts.title') }}</b-nav-item
                >
                <b-nav-item
                  to="/admin/adminMac"
                  exact
                  exact-active-class="active"
                  v-if="configRol.administrador.pestana.adminSucursales.permiso"
                  ><b-icon icon="box" aria-hidden="true" class="mr-2"></b-icon
                  >{{ $t('admin.bussiness.productRegeneraAdmin') }}</b-nav-item
                >
                <!--bundle-->
                <b-nav-item
                  to="/admin/bundles"
                  exact
                  exact-active-class="active"
                  v-if="configRol.administrador.pestana.adminSucursales.permiso"
                  ><b-icon icon="bag" aria-hidden="true" class="mr-2"></b-icon
                  >{{ $t('admin.bussiness.bundle') }}</b-nav-item
                >
                <!-- <b-nav-item
                  to="/admin/ingenes"
                  v-if="
                    configRol.administrador.pestana.adminDiscounts &&
                      configRol.administrador.pestana.adminDiscounts.permiso
                  "
                  exact
                  exact-active-class="active"
                ><b-icon icon="cash" aria-hidden="true" class="mr-2"></b-icon>
                  Propuesta Ingenes
                </b-nav-item> -->
              </b-nav>
              
            </b-card-header>

            <b-card-body>
              <router-view></router-view>
            </b-card-body>
          </b-card>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import MenuUser from '../components/MenuUser.vue';
import { AlertForm, ICON } from '../helpers/Alert';

export default {
  name: 'Admin',
  components: {
    MenuUser,
  },
  data: () => ({
    imageUser: '',
    configRol: '',
  }),
  created() {
    this.configRol = this.$store.state.configRol;
    if (this.configRol.administrador?.ventana === false) {
      this.$router.push({ name: 'Welcome' });
      AlertForm(
        `${this.$i18n.t('permissions.unauthorized')} ${this.$i18n.t('permissions.configAdmin')}`,
        this.$i18n.t('permissions.validateAdmin'),
        ICON.WARNING,
        'center',
        null
      );
    }
  },
  mounted() {
    this.imageUser = this.$store.state.userResponse && this.$store.state.userResponse.picture;
  },
};
</script>

<style lang="scss" scoped>
.container__admin {
  background-color: #f6f6f6;
  height: 100vh;
  width: 95%;
}

.bd-rd {
  border-radius: 20px;
}
/** card */
.card {
  border: none;
}
.tabs-card a {
  color: #464343;
}
.tabs-card .active {
  font-weight: bold;
}

.navbar-profile {
  border-radius: 20px;
  display: flex;
}
</style>
